(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7314],{

/***/ 64778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./affiliates1.png": 64833,
	"./affiliates2.png": 99294,
	"./article1.png": 94590,
	"./article2.png": 1923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64778;

/***/ }),

/***/ 80582:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature",
      function () {
        return __webpack_require__(6082);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates1.c0070cc6.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAM1BMVEX+5d704NX+7+v7+vjd5M7r5+TP2rz/5+KU2pOk2J3Oy8zi3+nGxcPq4dHf4tPZz+7T0dDOjqjRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nB3IQRKAIBAEsQYWZhZQ/P9rLc0xgGLw0ZUeApW086+0XYDa74gKauvM1YT6ns/uegEgZAE8oolrqQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 99294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates2.7641f663.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAMFBMVEXY9P7Y8vbm7db9yTrn+PnLzc/l57jr4Jry1m/3+PjExsbX3N3g3uji5sT30FzUzu5ACGK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3ISQ4AIQzEQKeTsMP8/7cj8MkqwIqMm3Z9Y9W9PGl+2qUISQH09eXqwMyRY/IDFB0A3NgNDvgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 94590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article1.6820bc2f.png","height":460,"width":694,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAMFBMVEUSJ0slOFk9U3Q1SWwdMVRZaIEGHUNPZ4hGXYJlfJoDFzwrQGNyiqrAx9KLlKbZ2+SrMHKJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nAXBhwEAIAzDMKcDyv7/WySQ7VEeNPIkARN/FwVNSpNgWfXRnQ8QkQC4xF0Z1gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 1923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article2.ad41d0ad.png","height":458,"width":726,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAHlBMVEXqwgPluwTyzQDuxwHasw/Ooh/XsC3Rr1G9m2O/p50bfbN2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nCXJwQ0AIAwDsQtJW9h/YYTw16zHNgbQNEln6myEFFX9Al0KGABqPGLlSwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 8058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero1.306345df.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEX08/T////v7uz9/P3e5OD4+fno2+nu7vLp6enf09/V0Nbt3/2/r6jH4sY/1g1MAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAN0lEQVR4nCXGxw3AQAwEsdEqO/TfrnEwXyQj+jYzfLf+VG2RDk+ERk5WN+BwxSv1iWJGdqIk7QMpYgEWGrmJSgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 79251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero3.1b65818e.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEXv7ezh2fvn4fv25fL18v3m4+Ln7O78+Pz18/T////47ufp7vvFpv/i0f/V1dPQtP/P0M/w6P/azvvtlTxZAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAPUlEQVR4nB3GQRKAIAwDwBTapgEU9f+PdXRPC7WGBAXZE9dZgu619uGC3KzNLzOTlYLGCBQE9R78QwdZegFDQAHITC0J7gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 61695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/only_solution2.dc5d6071.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEX////L9ePm5uv82M72/P/p+OXZ2drT1NTu+f/t6+35+P/2+fTc9PP/4tv47/nm+/K46fr08OHi1v7PvPtQ9mxIAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAO0lEQVR4nAXBBwLAIAgAsRNBhqPr/39tAsOHewLp7mNCvbW3LqW+03vcASmZIsBjZjaBvlprF3A0IpQfPloBn30PHkEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 7434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export companyLogos */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97005);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CaseStudyHoverCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23660);
/* harmony import */ var _case_studies_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15991);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);









const companyLogos = [
    {
        url: "9.png",
        name: "ABC Eyecare",
        haveCaseStudy: true,
        companyKey: "abc-eyecare".toLowerCase()
    },
    {
        url: "5.png",
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "10.png",
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "4.png",
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "2.png",
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "1.png",
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "6.png",
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "12.png",
        name: "Overstock Furniture",
        haveCaseStudy: true,
        companyKey: "overstock-furniture".toLowerCase()
    },
    {
        url: "11.png",
        name: "Lifestyle Design",
        haveCaseStudy: true,
        companyKey: "lifestyle-design".toLowerCase()
    },
    {
        url: "7.png",
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "3.png",
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    },
    {
        url: "8.png",
        name: "Benavest",
        haveCaseStudy: true,
        companyKey: "benavest".toLowerCase()
    }
];
const generateTestimonials = (companyKey)=>{
    let caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === companyKey);
    if (!caseStudy) {
        caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === "harry-corry-ltd");
    }
    const testimonial = {
        logo: caseStudy.companyLogo,
        company: caseStudy.name,
        quote: caseStudy.customerInsight.insight,
        name: caseStudy.customerInsight.by,
        title: caseStudy.customerInsight.authorPosition,
        avatar: caseStudy.customerInsight.image
    };
    return testimonial;
};
const AnimatedLogos = (param)=>{
    let { isInvert =false  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [hoveredIdx, setHoveredIdx] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoveredKey, setHoveredKey] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoverPosition, setHoverPosition] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        x: 0,
        y: 0
    });
    const handleLogoClick = (companyKey)=>{
        router.push("/signature/case-studies/".concat(companyKey));
    };
    const handleMouseEnter = (param)=>{
        let { idx , companyKey , event  } = param;
        const rect = event.currentTarget.getBoundingClientRect();
        const marqueeRect = event.currentTarget.closest(".marquee-container").getBoundingClientRect();
        // Calculate position relative to the marquee container
        const x = rect.left - marqueeRect.left + rect.width / 2;
        const y = rect.top - marqueeRect.top;
        let formattedY = y - 280;
        if (companyKey === "angelfire") {
            formattedY = y - 320;
        } else if (companyKey === "mancosa") {
            formattedY = y - 380;
        } else if (companyKey === "beaver") {
            formattedY = y - 320;
        }
        setHoverPosition({
            x,
            y: formattedY
        });
        setHoveredIdx(idx);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                pauseOnHover: true,
                children: companyLogos.map((logo, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-8 flex flex-col items-center group cursor-pointer relative h-[144px]",
                        onClick: ()=>handleLogoClick(logo.companyKey),
                        onMouseEnter: (e)=>handleMouseEnter({
                                idx,
                                companyKey: logo.companyKey,
                                event: e
                            }),
                        onMouseLeave: ()=>setHoveredIdx(null),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/company/").concat(logo.url),
                                alt: logo.name,
                                className: "object-contain transition duration-300 group-hover:filter ".concat(isInvert ? "invert" : ""),
                                width: 120,
                                height: 120,
                                loading: "lazy"
                            })
                        })
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimatedLogos);


/***/ }),

/***/ 23660:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const CaseStudyHoverCard = (param)=>{
    let { logo , company , quote , name , title , avatar , className =""  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-white shadow-lg hover:shadow-xl rounded-2xl p-5 w-80 max-w-sm border border-gray-50 z-50 transition-all duration-300 ".concat(styles.fadeScaleIn, " ").concat(className),
        style: {
            pointerEvents: "auto"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-10 h-10 rounded-lg overflow-hidden bg-gray-50 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logo,
                            alt: company,
                            fill: true,
                            className: "object-contain"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-semibold text-gray-900 text-base",
                        children: company
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("blockquote", {
                className: "text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3 italic",
                children: quote
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-3 border-gray-100"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mt-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-8 h-8 rounded-full overflow-hidden bg-gray-50 ring-2 ring-gray-100 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: avatar || "https://avatar.iran.liara.run/public/boy?username=".concat(name),
                            alt: name,
                            fill: true,
                            className: "object-cover"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-semibold text-gray-900 text-xs",
                                children: name
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-gray-500 text-[10px] mt-0.5",
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CaseStudyHoverCard)));


/***/ }),

/***/ 43155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export companyLogos */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89583);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CaseStudyHoverCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23660);
/* harmony import */ var _case_studies_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15991);
/* harmony import */ var react_icons_gr__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45155);
/* harmony import */ var _AnimatedLogos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7434);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);












const companyLogos = [
    {
        url: "1.png",
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "2.png",
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "3.png",
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "4.png",
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "5.png",
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "6.png",
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "7.png",
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "8.png",
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    }
];
const CustomersComponent = ()=>{
    const [hoveredIdx, setHoveredIdx] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const handleLogoClick = (companyKey)=>{
        router.push("/signature/case-studies/".concat(companyKey));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " mx-auto px-4 sm:px-6 lg:px-8 py-2 w-full text-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center mb-8 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-lg font-semibold tracking-wide uppercase mb-2",
                        children: "Trusted by Leading Brands Across Healthcare, Education, Retail, and Logistics"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col md:flex-row items-center justify-center gap-4 mb-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/case-studies/capterra-logo.png"),
                                        alt: "Capterra Logo",
                                        width: 20,
                                        height: 20,
                                        className: "rounded-full"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex items-center ",
                                        children: [
                                            ...Array(5)
                                        ].map((_, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaStar */ .QJe, {
                                                className: "text-yellow-400 text-sm"
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-medium ml-1",
                                        children: "4.9 rating"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_gr__WEBPACK_IMPORTED_MODULE_9__/* .GrGroup */ .ZMl, {
                                        className: "text-xl "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-medium",
                                        children: "50k+ businesses"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AnimatedLogos__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomersComponent);


/***/ }),

/***/ 18954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);





const BlogCard = (param)=>{
    let { blogImage , image , imageURL , imageWidth ="w-full md:h-[250px] lg:h-[367px] xl:h-[370px]" , title , genre , date , owner , desc , blogUrl , genreColor , customTitle , imageBorders , localAsset =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: blogUrl,
        target: "_blank",
        className: "group w-full flex flex-col gap-6 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex items-center justify-center mx-auto",
                children: [
                    (imageURL || image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: imageURL ? imageURL : localAsset ? __webpack_require__(64778)("./".concat(image)) : "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/v2/articles/").concat(image),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    }),
                    blogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "".concat(blogImage),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-left font-bold md:px-0 px-2 ".concat(customTitle ? customTitle : "text-xl leading-snug lg:text-[28px] md:leading-[36px]"),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:px-0 px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-left md:text-[22px] md:leading-[32px] text-base leading-snug font-medium text-gray-600",
                        children: desc
                    }),
                    owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-start items-center gap-2 mt-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                width: 48,
                                height: 48,
                                src: owner === null || owner === void 0 ? void 0 : owner.img,
                                alt: "Owner",
                                className: "rounded-full"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "md:text-xl text-base font-semibold text-gray-800",
                                        children: owner === null || owner === void 0 ? void 0 : owner.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "md:text-base text-sm font-semibold text-gray-500",
                                        children: owner === null || owner === void 0 ? void 0 : owner.title
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 18034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59183);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);






const Subscribe = (param)=>{
    let { heading ="Simple and Budget-Friendly Signing for Your Business" , paragraph ="One fixed price for unlimited signatures, templates, forms, and contracts—no extra charges for adding users and more signatures."  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-20 lg:py-40 mx-auto px-4 md:px-8 xxl:px-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-mxl mx-auto flex flex-col lg:flex-row gap-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            heading2: heading,
                            paragraph: paragraph
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col sm:flex-row gap-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                buttonPrimaryText: "Get Started",
                                buttonPrimaryUrl: "https://signature.boloforms.com/register?from=WEBSITE_BOTTOM_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .createUTMQueryParams */ .T0)({
                                    from: "WEBSITE_BOTTOM_BUTTON"
                                }))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full h-[500px] lg:h-auto lg:flex-1 relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(8058),
                            width: 10,
                            height: 10,
                            className: "moveRightAndCenterObject rounded-lg w-auto h-[50%] xs:h-[50%] sm:h-[70%] xl:h-[80%] imageBorders absolute left-[10%] top-1/2 z-10",
                            alt: "hero"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(61695),
                            width: 10,
                            height: 10,
                            className: "moveCornerLeftRotateLeftObject rounded-lg w-auto h-[30%] xs:h-[40%] sm:h-[50%] lg:h-[40%] xl:h-[65%] imageBorders absolute right-[5%] sm:right-[15%] md:right-[20%] xxl:right-[15%] top-0 lg:top-[-10%] z-10",
                            alt: "hero"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(79251),
                            width: 10,
                            height: 10,
                            className: "moveCornerLeftRotateRightObject rounded-lg w-auto h-[40%] xs:h-[50%] sm:h-[60%] lg:h-[50%] xl:h-[70%] imageBorders absolute right-[10%] sm:right-[30%] xxl:right-[20%] bottom-0 xl:bottom-[-20%] z-10",
                            alt: "hero"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Subscribe);


/***/ }),

/***/ 39569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ featuredBlogs; }
/* harmony export */ });
const featuredBlogs = [
    {
        image: "",
        imageURL: "https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-2--2025--05_49_16-PM.png",
        title: "The 5 Best AI Contract Review Software Tools for 2025",
        genreColor: "bg-red-100",
        genre: "CLM",
        date: "Jul 21, 2025",
        blogUrl: "https://www.bolosign.com/blog/the-5-best-ai-contract-review-software-tools-for-2025/",
        desc: "Compare the best AI contract review tools for 2025. See features, benefits, and practical tips to implement them at scale. Explore BoloSign’s unified solution.",
        owner: {
            img: "https://i.imgur.com/CbNehZg.png",
            name: "Paresh Deshmukh",
            title: "Co-Founder, BoloSign"
        }
    },
    {
        image: "",
        imageURL: "https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-4--2025--05_10_14-PM.png",
        title: "Are Clickwrap Agreements Legally Binding?",
        genreColor: "bg-green-100",
        genre: "CLM",
        date: "Jul 21, 2025",
        blogUrl: "https://www.bolosign.com/blog/are-clickwrap-agreements-legally-binding/",
        desc: "Learn if clickwrap agreements are legally binding, how they work, and key best practices for enforceability.",
        owner: {
            img: "https://i.imgur.com/CbNehZg.png",
            name: "Paresh Deshmukh",
            title: "Co-Founder, BoloSign"
        }
    }
];



/***/ }),

/***/ 6082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59183);
/* harmony import */ var _components_Slider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24747);
/* harmony import */ var _components_Cards_MiniCards__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6716);
/* harmony import */ var _components_MiniComponents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61325);
/* harmony import */ var _components_MiniComponents__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_MiniComponents__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(5434);
/* harmony import */ var _components_Cards_FeatureCards__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7041);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46687);
/* harmony import */ var _components_Cards_CardWithImage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2238);
/* harmony import */ var _components_Blog_BlogCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18954);
/* harmony import */ var _components_Cards_NavCard__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95665);
/* harmony import */ var react_icons_lia__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(81511);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(53854);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(51649);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(60155);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(8193);
/* harmony import */ var _components_Cards_ClientsTestimonial__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(59471);
/* harmony import */ var _components_Subscribe__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18034);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(10990);
/* harmony import */ var _gsap_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34715);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(56546);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(43138);
/* harmony import */ var _components_Security_Certifications__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30501);
/* harmony import */ var _constants_certifications__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1627);
/* harmony import */ var _components_Legality__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(95499);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(10447);
/* harmony import */ var components_customers__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(43155);
/* harmony import */ var _constants_blogs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(39569);
// import { Lexend } from "@next/font/google";

































// const lexend = Lexend({
//   weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
//   style: ["normal"],
//   subsets: ["latin"],
// });
gsap__WEBPACK_IMPORTED_MODULE_23__/* ["default"].registerPlugin */ .ZP.registerPlugin(_gsap_react__WEBPACK_IMPORTED_MODULE_15__/* .useGSAP */ .V, gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_24__.ScrollTrigger);
const customerImages = (/* unused pure expression or super */ null && ([
    "company1.png",
    "company2.png",
    "company3.png",
    "company4.png",
    "company5.png",
    "company6.png",
    "company7.png"
]));
const miniCardsData = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_25__/* .IoMdRepeat */ .hkg, {}),
        title: "Streamline Repetitive Operations",
        description: "Save time by automating routine tasks for scaling your small business."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_26__/* .IoRocketOutline */ .wkh, {}),
        title: "Accelerate Decision Making",
        description: "Speed up your business contracts for quicker decisions and enhanced agility."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_27__/* .MdOutlineGroups */ .snE, {}),
        title: "Enhance Team Collaboration",
        description: "Facilitate better teamwork with features designed for easy collaboration."
    }
];
const SlidingCardsData = {
    Forms: {
        nav: "Forms",
        title: "Collect important data and get signatures on forms that ensure compliance",
        description: "You can now effortlessly generate a range of business forms, including registration forms, purchase orders, feedback forms, and more, complete with signatures to guarantee legality and security.",
        buttonPrimaryUrl: "https://help.boloforms.com/en/articles/15419037-how-to-create-signature-forms"
    },
    PDFs: {
        nav: "PDFs",
        title: "Upload your business contracts and get it signed in a few clicks",
        description: "Get your PDFs signed in a secure and professional way to manage agreements with clients, suppliers, and employees.",
        buttonPrimaryUrl: "https://help.boloforms.com/en/articles/15431025-how-to-send-signature-request-on-pdf"
    },
    Templates: {
        nav: "Templates",
        title: "Customize PDF templates and reuse them anytime to meet your business needs",
        description: "Assign roles and reuse the pre-made templates that you created to save time and avoid repetitive tasks.",
        buttonPrimaryUrl: "https://help.boloforms.com/en/articles/15420696-how-to-create-a-pdf-template"
    }
};
const featuresData = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_27__/* .MdOutlineMail */ .G7V, {}),
        title: "Customizable Emails",
        styling: "bg-[#b8f6b7]",
        description: "Edit the emails you send with signature requests to match your business’ tone and style, making every interaction professional."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_27__/* .MdOutlineFileUpload */ .hU2, {}),
        title: "Seamless Upload",
        styling: "bg-[#f5daf6]",
        description: "Upload documents quickly and effortlessly, right from your platform, no technical skills needed."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_28__/* .AiOutlineAudit */ .SOh, {}),
        title: "Audit Trial",
        styling: "bg-[#fee5cd]",
        description: "See a detailed record of all actions taken on a document, including who viewed and signed it, for your peace of mind."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_27__/* .MdOutlineSecurity */ .AXp, {}),
        title: "Secure and Legally Binding",
        styling: "bg-[#fee5cd]",
        description: "Protect your business with legally recognized and secure electronic signatures."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lia__WEBPACK_IMPORTED_MODULE_29__/* .LiaFileSignatureSolid */ .up2, {}),
        title: "Multi-Recipient Signature Requests",
        styling: "bg-[#b8f6b7]",
        description: "Send signature requests to multiple individuals, allowing collaboration and simultaneous signing on a single document."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi__WEBPACK_IMPORTED_MODULE_30__/* .HiOutlineRefresh */ .zHJ, {}),
        title: "Real-Time Dashboard Updates",
        styling: "bg-[#f5daf6]",
        description: "Stay informed with immediate alerts on document progress, seeing which are signed and which are waiting, all from one dashboard."
    }
];
const whyChooseData = [
    {
        title: "Create Signature Forms",
        description: "Easily add signature fields to your forms using our intuitive form editor. Save time managing 100s of signatures without the hassle of creating individual documents.",
        image: "choose1.png"
    },
    {
        title: "Team up, without thinking about cost",
        description: "Even if we are a platform for small businesses to take e-signatures, we have enterprise-grade security to protect your contracts from potential threats and ensure compliance with international and industry-specific eSignature laws.",
        image: "choose2.png"
    },
    {
        title: "PDF templates for repeating contracts",
        description: "When you have a contract that is 95% the same but has some minor changes to be made to send to every new person, avoid the redundancy of recreating and remapping signature fields, customize minor details, and send to new recipients efficiently.",
        image: "choose3.png"
    }
];
const integrationsData = [
    {
        image: "zapier.png",
        title: "Zapier",
        description: "Automate tasks between 6000+ apps."
    },
    {
        image: "pabbly.png",
        title: "Pabbly",
        description: "Connect apps and automate business processes."
    },
    {
        image: "make.png",
        title: "Make",
        description: "Create custom workflows across multiple apps."
    },
    {
        image: "pipedrive.png",
        title: "Pipedrive",
        description: "Streamline sales management and tracking."
    },
    {
        image: "highlevel.png",
        title: "Highlevel",
        description: "Consolidate marketing efforts into one platform"
    },
    {
        image: "salesforce.png",
        title: "Salesforce",
        description: "Enhance customer relationship management seamlessly."
    }
];
const integrationsData2 = [
    {
        image: "hubspot.png",
        title: "Hubspot",
        description: "Enhance your marketing and sales data."
    },
    {
        image: "dynamics.png",
        title: "Ms Dynamics 365",
        description: "Integrate CRM and ERP capabilities."
    },
    {
        image: "drive.png",
        title: "Google Drive",
        description: "Store and access files from anywhere."
    },
    {
        image: "slack.png",
        title: "Slack",
        description: "Improve team communication and collaboration."
    },
    {
        image: "sheets.png",
        title: "Google Sheets",
        description: "Automate data entry and updates."
    },
    {
        image: "teams.png",
        title: "Microsoft Teams",
        description: "Collaborate and communicate within your team effortlessly."
    }
];
const Home = ()=>{
    let container = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    (0,_gsap_react__WEBPACK_IMPORTED_MODULE_15__/* .useGSAP */ .V)(()=>{
        let mm = gsap__WEBPACK_IMPORTED_MODULE_23__/* ["default"].matchMedia */ .ZP.matchMedia();
        mm.add("(max-width: 834px)", ()=>{
            let slidingCards = gsap__WEBPACK_IMPORTED_MODULE_23__/* ["default"].utils.toArray */ .ZP.utils.toArray(".sliding-card");
            slidingCards.forEach((card)=>{
                gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_24__.ScrollTrigger.create({
                    trigger: card,
                    start: "top 81px",
                    pin: true,
                    pinSpacing: false,
                    scrub: true
                });
            });
        });
        mm.add("(min-width: 835px)", ()=>{
            let slidingCards = gsap__WEBPACK_IMPORTED_MODULE_23__/* ["default"].utils.toArray */ .ZP.utils.toArray(".sliding-card");
            slidingCards.forEach((card)=>{
                gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_24__.ScrollTrigger.create({
                    trigger: card,
                    start: "top 97px",
                    pin: true,
                    pinSpacing: false,
                    scrub: true
                });
            });
        });
    }, {
        scope: container
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        ref: container,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloSign - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:domain",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://bolosign.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign - AI for Smart Contract Management"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col justify-center items-center gap-14 px-4 md:px-8 pb-32",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "max-w-screen-lg text-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading1: "AI for Smart Contract Management",
                                    paragraph: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies.",
                                    paragraphStyling: "max-w-[500px] mx-auto",
                                    buttonsStyling: "justify-center",
                                    buttonPrimaryText: "Get Started",
                                    buttonPrimaryUrl: "https://signature.boloforms.com/register?from=WEBSITE_HERO_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_20__/* .createUTMQueryParams */ .T0)({
                                        from: "WEBSITE_HERO_BUTTON"
                                    })),
                                    buttonSecondaryText: "Buy Now",
                                    buttonSecondaryUrl: "/signature/pricing",
                                    newTab: true,
                                    signaturePopupOpen: true
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Security_Certifications__WEBPACK_IMPORTED_MODULE_17__["default"], {
                                    certifications: _constants_certifications__WEBPACK_IMPORTED_MODULE_18__/* .securityCertifications */ .Di,
                                    displayText: false
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full mt-14 xl:mt-0 txl:w-[1440px] relative flex justify-center items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-5/6",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/arrow.svg"),
                                                width: 10,
                                                height: 10,
                                                className: "moveUpObject w-[38px] sm:w-[50px] xl:w-[80px] absolute -top-20 xl:-top-40 left-[30%] xl:left-1/4",
                                                alt: "hero"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/wheel.svg"),
                                                width: 10,
                                                height: 10,
                                                className: "rotateObject w-[38px] sm:w-[50px] xl:w-[60px] absolute -top-20 xl:-top-32 right-[30%] xl:right-1/4",
                                                alt: "hero"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/dashboard.png"),
                                                width: 10,
                                                height: 10,
                                                className: "rounded-lg w-full imageBorders",
                                                alt: "hero"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/hero1.png"),
                                        width: 10,
                                        height: 10,
                                        className: "moveCornerLeftObject rounded-lg w-[80px] xs:w-[100px] sm:w-[140px] md:w-[180px] lg:w-[250px] imageBorders absolute -top-12 sm:-top-20 lg:-top-32 left-0 -z-10 -rotate-12",
                                        alt: "hero"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/hero2.png"),
                                        width: 10,
                                        height: 10,
                                        className: "moveCornerRightObject rounded-lg w-[80px] xs:w-[100px] sm:w-[140px] md:w-[180px] lg:w-[250px] imageBorders absolute -top-12 sm:-top-20 lg:-top-40 right-0 -z-10 rotate-12",
                                        alt: "hero"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/hero3.png"),
                                        width: 10,
                                        height: 10,
                                        className: "moveDownObject rounded-lg w-[80px] xs:w-[100px] sm:w-[140px] md:w-[180px] lg:w-[250px] imageBorders absolute bottom-4 sm:bottom-8 md:bottom-20 left-0 z-10",
                                        alt: "hero"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/hero4.png"),
                                        width: 10,
                                        height: 10,
                                        className: "moveUpObject rounded-lg w-[80px] xs:w-[100px] sm:w-[140px] md:w-[180px] lg:w-[250px] imageBorders absolute bottom-4 sm:bottom-8 md:bottom-16 right-0 z-10",
                                        alt: "hero"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_customers__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-mxl mx-auto py-20 md:py-32 px-4 md:px-8 xxl:px-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col lg:flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "sm:w-[83%] lg:w-[50%]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            heading2: "Affordable eSignature solution for your team"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sm:w-[83%] lg:w-[45%] relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                paragraph: "Experience how easy document management can be with BoloSign. Our user-friendly platform is designed to help your team work better together, speeding up projects and enhancing productivity.",
                                                buttonPrimaryText: "Get Started",
                                                buttonPrimaryUrl: "https://signature.boloforms.com/register?from=WEBSITE_HERO_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_20__/* .createUTMQueryParams */ .T0)({
                                                    from: "WEBSITE_HERO_BUTTON"
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/wheel.svg"),
                                                width: 10,
                                                height: 10,
                                                className: "rotateObject w-[50px] sm:w-[70px] xl:w-[90px] absolute bottom-0 lg:-bottom-20 right-6",
                                                alt: "hero"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-20 w-full flex flex-col lg:flex-row items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "md:w-3/4 lg:flex-1 relative",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/section3.png"),
                                                width: 10,
                                                height: 10,
                                                className: "rounded-lg w-full",
                                                alt: "hero"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute bottom-6 left-6",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MiniComponents__WEBPACK_IMPORTED_MODULE_7__.BasicChip, {
                                                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_27__/* .MdOutlineElectricBolt */ .RQt, {}),
                                                    text: "Increase Productivity With BoloSign Signature"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "md:w-3/4 lg:flex-1 flex justify-center lg:justify-end items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_MiniCards__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            cardsData: miniCardsData,
                                            cardsStyling: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6 lg:gap-10"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-mxl mb-28 sm:mb-40 mx-auto px-4 md:px-8 xxl:px-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Legality__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-mxl pb-20 mx-auto px-4 md:px-8 xxl:px-0 flex flex-col gap-4 sm:gap-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-center max-w-screen-lg mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading2: "Why BoloSign Is the Best Solution for Your Small Business",
                                    paragraph: "We understand that streamlined document management is essential for maximizing productivity and ensuring the success of your projects.",
                                    paragraphStyling: "max-w-screen-sm mx-auto"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "sliding-cards relative w-full flex flex-col gap-20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sliding-card z-10 bg-white w-full sm:w-5/6 lg:w-full mx-auto flex flex-col lg:flex-row justify-between border border-gray-600 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full lg:w-1/2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_NavCard__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    activeNav: "Forms",
                                                    cardsData: SlidingCardsData
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "h-[370px] xxs:h-[400px] sm:h-[550px] lg:h-auto w-full lg:w-1/2 relative bg-sky-200",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/forms3.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveRightObject rounded-lg w-auto h-[19%] absolute z-10 top-[12%] left-[10%]",
                                                        alt: "hero"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/forms1.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveCornerTopObject rounded-lg w-auto h-[65%] xxs:h-[70%] xs:h-[80%] lg:h-[70%] imageBorders absolute z-10 top-[10%] right-[10%]",
                                                        alt: "hero"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/forms2.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveCornerBottomObject rounded-lg w-auto h-[50%] xxs:h-[50%] xs:h-[60%] lg:h-[50%] imageBorders absolute left-[10%] bottom-[10%]",
                                                        alt: "hero"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sliding-card z-10 bg-white w-full sm:w-5/6 lg:w-full mx-auto flex flex-col-reverse lg:flex-row-reverse justify-between border border-gray-600 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full lg:w-1/2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_NavCard__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    activeNav: "PDFs",
                                                    cardsData: SlidingCardsData
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "bg-purple-200 h-[370px] xxs:h-[400px] sm:h-[550px] lg:h-auto w-full lg:w-1/2 relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/pdf4.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "rounded-lg w-auto h-[50%] xs:h-[60%] imageBorders absolute z-10 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
                                                        alt: "hero"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/pdf3.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveRightAndCenterObject rounded-lg w-auto h-[30%] lg:h-[35%] imageBorders absolute left-[5%] top-1/2 z-10",
                                                        alt: "hero"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/pdf1.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveUpObject rounded-lg w-auto h-[40%] imageBorders absolute right-[5%] top-[10%] z-10",
                                                        alt: "hero"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/pdf2.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveDownObject rounded-lg w-auto h-[40%] imageBorders absolute right-[5%] bottom-[8%] z-10",
                                                        alt: "hero"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sliding-card1 z-10 bg-white w-full sm:w-5/6 lg:w-full mx-auto flex flex-col lg:flex-row justify-between border border-gray-600 rounded-lg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-full lg:w-1/2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_NavCard__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    activeNav: "Templates",
                                                    cardsData: SlidingCardsData
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "bg-red-100 h-[370px] xxs:h-[400px] sm:h-[550px] lg:h-auto w-full lg:w-1/2 relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/template2.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "rounded-lg w-auto h-[50%] xs:h-[70%] imageBorders absolute z-10 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
                                                        alt: "hero"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/template3.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveUpObject rounded-lg w-auto h-[30%] lg:h-[40%] imageBorders absolute left-[5%] xs:left-[5%] bottom-[10%] z-10",
                                                        alt: "hero"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/template1.png"),
                                                        width: 10,
                                                        height: 10,
                                                        className: "moveDownObject rounded-lg w-auto h-[40%] lg:h-[50%] imageBorders absolute right-[5%] top-[5%] z-10",
                                                        alt: "hero"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-y-2 border-gray-700 bg-[#d7f3fe] py-20 mx-auto px-4 md:px-8 xxl:px-0 flex flex-col gap-4 sm:gap-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-center max-w-screen-lg mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading2: "As a Company, We Offer Our Customers Cool Features",
                                    paragraph: "We're dedicated to delivering exceptional results, fostering lasting relationships, and ensuring our clients' success in an ever competitive digital marketplace.",
                                    paragraphStyling: "max-w-screen-sm mx-auto"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "max-w-screen-mxl mx-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_FeatureCards__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        cardsData: featuresData,
                                        featuresStyling: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-10 flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .ButtonPrimary */ .DF, {
                                            buttonText: "All Features",
                                            buttonUrl: "#"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "max-w-screen-mxl py-20 lg:py-28 mx-auto px-4 md:px-8 xxl:px-0 flex flex-col gap-4 sm:gap-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full sm:w-[80%] md:w-[70%] lg:w-full mx-auto flex flex-col justify-center items-center gap-12 sm:gap-28",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex flex-col-reverse lg:flex-row justify-center items-center gap-20",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_CardWithImage__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                title: whyChooseData[0].title,
                                                description: whyChooseData[0].description,
                                                image: whyChooseData[0].image
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex-1 relative",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    heading2: "BoloSign - Why Choose Us",
                                                    paragraph: "We allow you to efficiently manage document workflows, send multi-recipient signatures, and receive real-time updates, significantly streamlining your operations. Each transaction is secure and legally compliant, backed by robust security features and a detailed audit trail.",
                                                    buttonPrimaryText: "Watch Trailer",
                                                    buttonPrimaryUrl: "https://www.youtube.com/watch?v=HE4oDN_T12Q"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/wheel.svg"),
                                                    width: 10,
                                                    height: 10,
                                                    className: "rotateObject w-[50px] sm:w-[70px] xl:w-[90px] absolute bottom-0 lg:-bottom-20 right-6",
                                                    alt: "hero"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex flex-col lg:flex-row justify-center gap-12 sm:gap-20",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_CardWithImage__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            title: whyChooseData[1].title,
                                            description: whyChooseData[1].description,
                                            image: whyChooseData[1].image
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_CardWithImage__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            title: whyChooseData[2].title,
                                            description: whyChooseData[2].description,
                                            image: whyChooseData[2].image
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex flex-col lg:flex-row justify-center items-center gap-20",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex-1 relative",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                    heading2: "With the only eSignature Solution made for Small Businesses",
                                                    paragraph: "We understand the needs of your small business. That’s why we provide a centralized platform that enhances the efficiency of signatures in contracts, agreements, and other legal documents crucial to your business operations at a very affordable price.",
                                                    buttonPrimaryText: "Get Started",
                                                    buttonPrimaryUrl: "https://signature.boloforms.com/register?from=WEBSITE_HERO_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_20__/* .createUTMQueryParams */ .T0)({
                                                        from: "WEBSITE_HERO_BUTTON"
                                                    }))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/wheel.svg"),
                                                    width: 10,
                                                    height: 10,
                                                    className: "rotateObject w-[50px] sm:w-[70px] xl:w-[90px] absolute bottom-0 lg:-bottom-20 right-6",
                                                    alt: "hero"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex-1 relative w-[90%] sm:w-full",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/only_solution1.png"),
                                                    width: 10,
                                                    height: 10,
                                                    className: "rounded-lg w-full",
                                                    alt: "hero"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_16__.BASE_ASSETS_URL, "/v2/landing-page/only_solution2.png"),
                                                    width: 10,
                                                    height: 10,
                                                    className: "imageBorders moveDownObject rounded-lg absolute -left-5 sm:-left-10 bottom-10 w-[130px] sm:w-[200px]",
                                                    alt: "hero"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-y-2 border-gray-700 bg-red-100 py-20 lg:py-40 mx-auto px-4 md:px-8 xxl:px-0 flex flex-col gap-4 sm:gap-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-center max-w-screen-md mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading2: "Integrate Some of Your Favorite Software",
                                    paragraph: "Connect with your CRM, email marketing platform, and more to simplify your business processes.",
                                    paragraphStyling: "max-w-screen-sm mx-auto"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Slider__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    cardsData: integrationsData
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Slider__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    cardsData: integrationsData2,
                                    direction: "right"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-20 lg:pt-28 flex flex-col gap-6 relative max-w-screen-mxl mx-auto px-4 md:px-8 xxl:px-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_ClientsTestimonial__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-mxl mx-auto px-4 md:px-8 xxl:px-0 py-20 lg:py-28 flex flex-col gap",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-center max-w-screen-md mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    heading2: "Take a Look at Our Featured Articles",
                                    paragraph: "These articles will guide you on how to simplify office work, boost your efficiency, and concentrate on expanding your business.",
                                    paragraphStyling: "max-w-[600px] mx-auto"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-10 flex flex-col md:flex-row gap-6 sm:max-w-[80%] md:max-w-full mx-auto",
                                children: _constants_blogs__WEBPACK_IMPORTED_MODULE_22__/* .featuredBlogs.map */ .X.map((card, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Blog_BlogCard__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        ...card,
                                        imageWidth: "w-full md:h-[290px] xl:h-[330px]"
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9866,6158,8802,4774,9642,6137,5991,4599,9471,5499,7111,9774,2888,179], function() { return __webpack_exec__(80582); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);